module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/12_8874b238aba4e7e1bb1721b52a6b8841.jpg";